import { Package, PackageClientType } from '@lib/insurance-packages/data-access';

export interface ClientCreateUiState {
  uiStep: ClientCreateUiStep;
  data: ClientCreateParsedData | null;
  clientProfileAge: ClientProfileAge | null;
  packages: {
    packagesList: Package[];
    loadingPackages: boolean;
  };
}

export enum ClientCreateUiStep {
  JsonParser = 0,
  BasicInfoForm = 1,
  AdditionalInfoForm = 2,
  Summary = 3,
}

export enum ClientProfileAge {
  Adult,
  Child,
}

export interface ClientCreateParsedData {
  birthDate: Date;
  gender: string;
  lastName: string;
  firstName: string;
  middleName: string;
  clientType: PackageClientType;
  contracts: {
    contractId: string;
    contractNumber: string;
    activeFrom: string;
    activeTo: string;
    packageId: string;
  }[];
  pepRelatedInfo: {
    isPEP: boolean;
    IncomeRange: string;
    Position: string;
  };
  passportDataAbsent?: boolean;
  verificationInfo: {
    passportNumber: string | null;
    issueDate: Date | null;
    issuer: string | null;
    taxPayerNumber: string;
  };
  legalAddress: string | null;
  actualAddress: string | null;
  email?: string;
  phoneNumber?: string;
  phoneCode?: string;
  companyName?: string;
  helsiPatientId?: string;
  status?: string;
}
